import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));

// Remove logs do HMR do console
// if (environment.production === false) {
//   const HMR_FILTER = ['[HMR]', '[NG HMR]'];

//   function filter(method: typeof console.log) {
//     return new Proxy(method, {
//       apply(target, thisArg, args: any[]) {
//         if (args.length && typeof args[0] === 'string' && HMR_FILTER.some(str => args[0].includes(str))) {
//           return; // não imprime
//         }
//         return Reflect.apply(target, thisArg, args);
//       },
//     });
//   }

//   console.log = filter(console.log);
//   console.warn = filter(console.warn);
//   console.info = filter(console.info);
// }
